import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import React from "react";
import { AppButton, AppOutlineButton } from "../StyledComponent";

const UnsavedChangesDialog = ({ open, onConfirm, onCancel }) => {
  return (
    <Dialog
      open={open}
      // onClose={onCancel}

      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: "10px",
          minWidth: 400,
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">
        <Typography variant="h5" sx={{ fontWeight: 500 }}>
          Leave Page?
        </Typography>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ py: 3 }}>
        <DialogContentText id="alert-dialog-description">
          You have unsaved changes. Are you sure you want to leave? Your
          progress will be lost.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2, justifyContent: "flex-end", gap: 1 }}>
        <AppOutlineButton onClick={onCancel} size="small" sx={{ fontSize: 15 }}>
          Cancel
        </AppOutlineButton>
        <AppButton
          onClick={onConfirm}
          autoFocus
          size="small"
          variant="contained"
        >
          Save
        </AppButton>
      </DialogActions>
    </Dialog>
  );
};

export default UnsavedChangesDialog;
